import { Typography } from '@mui/material';
import { useKeycloak } from '@react-keycloak/web';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

function Redirect() {
  const navigate = useNavigate();
  const { keycloak } = useKeycloak();
  const { t } = useTranslation('login');

  const isSuper =
    keycloak.hasResourceRole('SUPER', process.env.REACT_APP_KEYCLOAK_CLIENT_ID) || process.env.REACT_APP_ENV === 'dev';

  useEffect(() => {
    if (isSuper) {
      navigate('/general');
    } else {
      navigate('/general'); // modificar para o caso de precisarmos de outra página padrão por permissão
    }
  }, [isSuper, navigate]);

  return (
    <div style={{ textAlign: 'center', width: '100%' }}>
      <Typography sx={{ marginTop: '42px', marginLeft: '50px' }}>
        {t('Seu usuário não tem permissões no sistema')}
      </Typography>
    </div>
  );
}
export default Redirect;
